<template>
  <div class="notice-Tab">
    <el-row :gutter="40" class="clearfix-tab">
      <el-col :gutter="40" class="clearfix">
        <div class="clearfix notice-block">
          <div class="hande">
            <!-- <svg-icon
              icon-class="work-dynamic"
              class="icon-market-dynamic"
            ></svg-icon> -->
            <span class="title fl">行业要闻</span>
          </div>
          <div class="content">
            <div
              class=" focusNew ccui-clearfix"
              v-for="(item1, index1) in list1"
              :key="index1"
            >
              <div class="dot"></div>
              <!-- <i class="icon-ccui-next notice-arrow"></i> -->
              <a @click="handleDetail(item1, '4', '3')">
                <span class="ellipsis" :title="item1.cont">{{
                  item1.cont
                }}</span>
                <!-- <span style="color:#999999;">[{{ item3.time }}]</span> -->
              </a>
            </div>
          </div>
          <el-link
            :underline="false"
            type="info"
            class="notice-more"
            @click="handleViewAll('list1')"
          >
            更多 ></el-link
          >
        </div>
      </el-col>

      <el-col :gutter="40" class="clearfix">
        <div class="clearfix notice-block">
          <!-- <svg-icon
            icon-class="market-dynamic"
            class="icon-market-dynamic"
          ></svg-icon> -->
          <div class="title">市场行情</div>
          <div class="banner">
            <el-image
              style=" width: 324px; height: 91px;"
              :src="require('@/basa/assets/images/marketSituation.png')"
            ></el-image>
          </div>
          <div
            class=" focusNews ccui-clearfix"
            v-for="(item2, index2) in list2"
            :key="index2"
          >
            <div class="dot"></div>
            <!-- <i class="icon-ccui-next notice-arrow"></i> -->
            <a @click="handleDetail(item2, '5', '2')">
              <span class="ellipsis" :title="item2.cont">{{ item2.cont }}</span>
              <!-- <span style="color:#999999;">[{{ item3.time }}]</span> -->
            </a>
          </div>
          <el-link
            :underline="false"
            type="info"
            class="notice-more"
            @click="handleViewAll('list2')"
          >
            更多 ></el-link
          >
        </div>
      </el-col>

      <el-col :gutter="40" class="clearfix">
        <div class="clearfix lastCol notice-block">
          <!-- <svg-icon icon-class="price-info" class="icon-price-info"></svg-icon> -->
          <div class="title ">分析报告</div>
          <div class="banner">
            <el-image
              style=" width: 324px; height: 91px;"
              :src="require('@/basa/assets/images/analysisReport.png')"
            ></el-image>
          </div>
          <div
            class="focusNews ccui-clearfix"
            v-for="(item3, index3) in list3"
            :key="index3"
          >
            <div class="dot"></div>
            <!-- <i class="icon-ccui-next notice-arrow"></i> -->
            <a @click="handleDetail(item3, '6', '4')">
              <span class="ellipsis" :title="item3.cont">{{ item3.cont }}</span>
              <!-- <span style="color:#999999;">[{{ item3.time }}]</span> -->
            </a>
          </div>

          <el-link
            :underline="false"
            type="info"
            class="notice-more"
            @click="handleViewAll('list3')"
          >
            更多 ></el-link
          >
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listFaqProblem } from "@/app/shop/api/shopping";
import request from "@/config/utils/request";
import moment from "moment";
import { announcementPageSource } from "@/setting/setting";
export default {
  name: "noticeTab",
  props: ["newsList"],
  computed: {
    getNewsList() {
      return this.newsList;
    }
  },
  activated() {
    this.init();
  },
  deactivated() {
    this.list1 = [];
    this.list2 = [];
    this.list3 = [];
    this.childrenList1 = [];
    this.childrenList2 = [];
    this.activeName1 = "tab0";
    this.activeName2 = "tab0";
    this.marketDynamicUrl = "";
    this.priceInfoUrl = "";
  },
  data() {
    return {
      list1: [],
      list2: [],
      list3: [],
      childrenList1: [],
      childrenList2: [],
      activeName1: "tab0",
      activeName2: "tab0",
      source: announcementPageSource,
      marketDynamicUrl: "",
      priceInfoUrl: "",
      interfaceType: "4" // 获取市场动态下的：分析报告、市场详情、行业要闻  默认是：分析报告
    };
  },
  methods: {
    init() {
      listFaqProblem({
        faqClassifyId: 1553,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          res.data.data.faqProblemBOs.map((item, index) => {
            // this.list1.push({
            //   name: "tab" + (index + 1),
            //   label: item.faqName,
            //   columnUrl: item.columnUrl,
            //   list: []
            // });
            this.getData(item.columnUrl, item.faqName);
          });
          // this.marketDynamicUrl = this.list1[0].columnUrl;
          // this.getData(
          //   this.list1,
          //   "list1",
          //   "industryNews"
          // );
        }
      });
    },
    handleOp(row, source) {
     this.$router.push({
        path: "/announcementDetail",
        query: {
          id: row.id,
          source: source,
          schemeId: row.schemeId
        }
      });
    },
    handleClickOne(tab) {
      this.childrenList1 = [];
      // this.marketDynamicUrl = tab.$attrs.url;
      this.getData(tab.$attrs.url, "childrenList1", "marketDynamic");
    },

    handleClickTwo(tab) {
      this.childrenList2 = [];
      // this.priceInfoUrl = tab.$attrs.url;
      this.getData(tab.$attrs.url, "childrenList2", "priceInfoUrl");
    },

    getData(url, list, type) {
      if (type && type == "marketDynamic") {
        // 获取市场动态下的：分析报告4、市场详情2、行业要闻3  默认是：分析报告
        this.interfaceType = url.split("=")[1];
      }
      if (type && type == "priceInfoUrl") {
        // 使用encodeURIComponent转码URL中的中文
        const encodedQuery = encodeURIComponent(url.split("title=")[1]);
        url = url.split("title=")[0] + "title=" + encodedQuery;
      }
      request({
        url: url,
        methods: "get",
        data: {
          pageNo: 1,
          pageSize: 10,
          isShowPageLoading: true
        },
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          let data = [];
          let arr =
            list == "行业要闻"
              ? res.data.data.rows.slice(0, 8)
              : res.data.data.rows.slice(0, 6);
          data = arr.map(item => {
            return {
              ...item,
              cont: item.title,
              time: item.pubdate ? moment(item.pubdate).format("MM-DD") : "",
              newUrl: item.newUrl,
              source:
                list === "childrenList1"
                  ? announcementPageSource.marketDynamic
                  : announcementPageSource.priceInfo,
              textInfo: item.textInfo
            };
          });
          if (list == "行业要闻") {
            this.list1 = data;
          }
          if (list == "市场行情") {
            this.list2 = data;
          }
          if (list == "分析报告") {
            this.list3 = data;
          }
          console.log(data, list, "request");
        }
      });
    },

    //点击查看详情
    handleDetail(item, type, interfaceType) {
      let pageData = {
        title: item.cont,
        pubdate: item.pubdate,
        textInfo: item.textInfo
      };
      localStorage.setItem("detailInfo", JSON.stringify(pageData));
      this.$router.push({
        path: "/announcementDetail",
        query: {
          source: type,
          interfaceType: interfaceType
        }
      });
    },

    //查看全部
    handleViewAll(value) {
      this.$router.push({
        path: "/announcementsList",
        query: {
          source:
            value == "list1"
              ? "4"
              : value == "list2"
              ? "5"
              : value == "list3"
              ? "6"
              : "",
          interfaceType:
            value == "list1"
              ? 3
              : value == "list2"
              ? 2
              : value == "list3"
              ? 4
              : ""
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.notice-Tab {
  background: #ffffff;
  padding: 30px 20px 30px 20px;
  .el-row {
    display: flex;
    justify-content: space-between;
  }
  .el-col {
    width: 365px;
    height: 380px;
    background: #f7f7f7;
    box-sizing: border-box;
    &:first-of-type {
      width: 365px;
    }
    // &:nth-of-type(2) {
    //   margin-right: 10px;
    // }
  }
  margin-top: 20px;
  .title {
    font-weight: 500;
    font-size: 20px;
    color: #222222;
    line-height: 28px;
    text-align: left;
    margin-right: 20px;
  }
  .banner {
    // margin-bottom: 7px;
  }
  .focusNews {
    height: 18px;
    // font-family: PingFangSC-Regular;
    font-family: PingFangSC, PingFang SC;
    font-size: 13px;
    font-weight: 400;
    color: #4a4a4a;
    letter-spacing: 0;
    line-height: 18px;
    margin-bottom: 12px;
    box-sizing: border-box;
    margin-bottom: 20px;
    .dot {
      position: absolute;
      left: 0px;
      width: 3px;
      height: 3px;
      background: #4a4a4a;
      border-radius: 50%; /* 圆形属性 */
      display: inline-block; /* 使其可以与其他元素水平排列 */
      margin-top: 8px;
      margin-right: 6px;
    }
    a {
      span:first-of-type {
        display: inline-block;
        width: 319px;
        margin-left: 5px;
        font-weight: 400;
        font-size: 16px;
        // color: #4A4A4A;
        line-height: 22px;
      }
    }
  }
  .focusNew {
    height: 18px;
    // font-family: PingFangSC-Regular;
    font-family: PingFangSC, PingFang SC;
    font-size: 13px;
    color: #4a4a4a;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 400;
    margin-bottom: 12px;
    box-sizing: border-box;
    margin-bottom: 20px;
    .dot {
      position: absolute;
      left: 0px;
      width: 3px;
      height: 3px;
      background: #4a4a4a;
      border-radius: 50%; /* 圆形属性 */
      display: inline-block; /* 使其可以与其他元素水平排列 */
      margin-top: 8px;
      margin-right: 6px;
    }
    a {
      span:first-of-type {
        display: inline-block;
        width: 314px;
        font-weight: 400;
        font-size: 16px;
        // color: #4a4a4a;
        line-height: 22px;
        margin-left: 10px;
      }
    }
  }
  /deep/ .el-tabs__header {
    margin-bottom: 20px;
  }
}
.hande {
  width: 100%;
  height: 30px;
}
.content {
  margin-top: 19px;
}
/deep/.lastCol .el-tabs__nav-wrap {
  padding-top: 3px;
  padding-right: 60px;
}
/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__nav-prev {
  line-height: 24px;
}

/deep/ .el-tabs__nav-next {
  line-height: 24px;
  right: 40px;
}
/deep/ .el-tabs__item {
  padding: 0;
  font-size: 12px;
  line-height: 19px;
  font-weight: 400;
  color: #9b9b9b;
  text-align: center;
  margin-right: 10px;
  min-width: 55px;
  height: 20px;
  border-radius: 16px;
  box-sizing: border-box;
}
/deep/.lastCol .el-tabs__item {
  margin-right: 5px;
  min-width: 35px;
}
/deep/ .el-tabs__item:hover {
  color: #0089ef;
  background: rgba(0, 137, 239, 0.06);
  border: 1px solid #0089ef;
  border-radius: 16px;
}
/deep/ .el-tabs__item.is-active {
  color: #ffffff;
  background: #0089ef;
  border-radius: 16px;
  border: none;
  border: 1px solid #0089ef;
}
.notice-more {
  position: absolute;
  top: 0;
  right: 0;
  line-height: 30px;
  &:hover {
    color: #0089ef;
  }
}
.notice-block {
  position: relative;
  margin-top: 20px;
}
.icon-market-dynamic {
  width: 20px;
  height: 20px;
  float: left;
  padding-top: 5px;
  padding-right: 10px;
}
.icon-price-info {
  width: 19px;
  height: 21px;
  float: left;
  padding-top: 5px;
  padding-right: 10px;
}
</style>
